import { AxiosInstance } from "../../../axios/axiosInstance"
import { apiRoutes } from "../../../utils/ApiRoutes"

export const getTransactionHistoryApi = async (data?: any) => {
    const response = await AxiosInstance.post(apiRoutes?.transactionHistory, data)
    return response
}

export const getCreditHistoryApi = async () => {
    const response = await AxiosInstance.get(apiRoutes?.creditHistory)
    return response
}
